import React from 'react';

import Link from 'next/link';

import { ElementsColumn } from './styles';

const NonFeedFooterColumn = ({ slice }) => {
  const heading = slice.primary.route ? (
    <Link href={slice.primary.route}>
      <p>{slice.primary.title}</p>
    </Link>
  ) : (
    <p>{slice.primary.title}</p>
  );

  return (
    <ElementsColumn>
      {heading}
      {!!slice.items?.length && (
        <ul>
          {slice.items.map((item) => {
            if (item.route) {
              return (
                <li key={item.title}>
                  <Link href={item.route}>{item.title}</Link>
                </li>
              );
            }
            if (item.link) {
              return (
                <li key={item.title}>
                  <Link href={item.link.url} target="_blank">
                    {item.title}
                  </Link>
                </li>
              );
            }
            return null;
          })}
        </ul>
      )}
    </ElementsColumn>
  );
};

export default NonFeedFooterColumn;
